<template>
  <ModalV2
    ref="volumesModal"
    :close-on-click-outside="true"
    title="Volumes"
  >
    <template #body>
      <table class="volumes-table">
        <thead>
          <th v-for="header in tableHeaders" :key="header">
            {{header}}
          </th>
        </thead>

        <tbody>
          <tr v-for="item in volumes" :key="item.id">
            <td
              v-for="(value, key) in tableHeaders"
              :key="key"
              :data-label="value"
            >
              {{formatVolumeDimension(key, item[key])}}
            </td>
          </tr>

        </tbody>
      </table>
    </template>

    <template #footer>
      <button class="mui-button mui-button--primary" @click="close">
        Fechar
      </button>
    </template>
  </ModalV2>
</template>


<script>
import ModalV2 from "commons/js/components/atoms/ModalV2.vue";
import { formatVolumeDimension } from "commons/js/utils/volumes";

export default {

  props: {
    volumes: {
      type: Array,
      required: true
    }
  },

  components : {
    ModalV2,
  },

  data() {
    return {
      tableHeaders : {
        times: "qtd.",
        height: "altura",
        width: "largura",
        length: "comprimento",
        weight: "peso"
      }
    }
  },

  methods: {
    formatVolumeDimension,

    open() {
        this.$refs.volumesModal.open();
      },

    close() {
      this.$refs.volumesModal.close();
    }
  }
}
</script>

<style lang="stylus" scoped>

.volumes-table
  width 100%
  border-collapse collapse
  color #3b3f51

  th, td
    padding 8px
    text-align center
    display block

  thead
    display none

  tr
    display block
    margin-bottom 15px
    border 1px solid #ccc
    border-radius 4px

  td
    position relative
    padding-left 50%

    &::before
      content attr(data-label)
      position absolute
      left 0
      width 50%
      padding-left 15px
      font-weight bold
      text-align left
      text-transform uppercase

  @media screen and (min-width: 720px)
    thead
      display table-header-group
      font-weight bold
      text-transform uppercase

    tr
      display table-row
      border none

      &:nth-child(odd)
        background-color #f2f6f9

    td, th
      display table-cell
      padding-left 0

    td::before
      display none

</style>
